import React from "react";
import { Link } from "react-router-dom";

const Category = () => {
  return (
    <main className="z-50 text-black flex-row items-center justify-center gap-12 hidden nav:flex">
      <Link
        to="/buscador/encontrado"
        className="flex flex-col items-center justify-center border-4  border-gray-200 text-center shadow-md bg-white rounded-lg hover:border-[#FC9F5B] transition duration-300 border-solid cursor-pointer transform hover:scale-105"
      >
        <img src="/img/Perdido.svg" alt="Perdido" className="w-56" />
        <h3 className="font-main text-xl font-medium p-2 ">Perdí mi amigo</h3>
      </Link>

      <Link
        to="/buscador/buscando"
        className="flex flex-col items-center justify-center border-4 border-gray-200 text-center shadow-md bg-white rounded-lg hover:border-[#FC9F5B] transition duration-300 border-solid cursor-pointer transform hover:scale-105"
      >
        <img src="/img/Encontrado.svg" alt="Encontrado" className="w-56" />
        <h3 className="font-main text-xl font-medium p-2">Encontré un amigo</h3>
      </Link>

      <Link
        to="/buscador/adopcion"
        className="flex flex-col items-center justify-center border-4 border-gray-200 text-center shadow-md bg-white rounded-lg hover:border-[#FC9F5B] transition duration-300 border-solid cursor-pointer transform hover:scale-105"
      >
        <img src="/img/Adoptar.svg" alt="Adoptar" className="w-56" />
        <h3 className="font-main text-xl font-medium p-2">Adoptar un amigo</h3>
      </Link>

      <Link
        to="/compartir?estado=4"
        className="flex flex-col items-center justify-center border-4 border-gray-200 text-center shadow-md bg-white rounded-lg hover:border-[#FC9F5B] transition duration-300 border-solid cursor-pointer transform hover:scale-105"
      >
        <img src="/img/Adopcion.svg" alt="Adopción" className="w-56" />
        <h3 className="font-main text-xl font-medium p-2">Poner en adopción</h3>
      </Link>
    </main>
  );
};

export default Category;
